<template>
<div class="page-wrapper">
    <div class="container-fluid">

        <!--div class="page-header d-print-none">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col">
                <h2 class="page-title">
                  Inbox
                </h2>
              </div>
            </div>
          </div>
        </div-->

        <div class="page-body">
            <div class="container-fluid">

                <div class="card flex-fill">
                    <div v-if="loading || loadingDetail" className="inline ? '' : 'page-wrapper'" class="position-relative">
                        <div class="progress progress-sm position-absolute w-100">
                            <div class="progress-bar progress-bar-indeterminate"></div>
                        </div>
                    </div>

                    <div class="row g-0 flex-fill">
                        <div class="col-12 col-lg-5 col-xl-3 border-end d-flex flex-column">
                            <!--div class="card-header d-md-block">
                                <div class="input-icon">
                                    <span class="input-icon-addon">
                                        <icon icon="search" height="24" class="icon-1 d-block"></icon>
                                     </span>
                                    <input type="text" value="" class="form-control" placeholder="Search…"
                                           aria-label="Search">
                                </div>
                            </div-->
                            <div class="card-header">
                                <button class="btn btn-secondary" @click="makeExport()">Export</button>
                            </div>
                            <div class="card-body p-0 scrollable flex-fill" style="max-height: calc(100vh - 180px)">
                                <div class="nav flex-column nav-pills" role="tablist">

                                    <a v-for="item in items" :key="item.id" @click="loadDetail(item)" class="nav-link text-start mw-100 p-3"
                                       data-bs-toggle="pill" role="tab" aria-selected="false" tabindex="-1">
                                        <div class="row align-items-center flex-fill">
                                            <div class="col-auto">
                                                <span class="avatar avatar-1">{{ convertEmoji(item.country_code) }}</span>
                                            </div>
                                            <div class="col text-body">
                                                <div>{{ formatDuration(item.duration) }}</div>
                                                <div class="text-secondary text-truncate w-100">{{ formatCreated(item.created) }}</div>
                                            </div>
                                        </div>
                                    </a>

                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 col-xl-9 d-flex flex-column">
                            <div class="card-body scrollable">
                                <div class="chat">
                                    <div class="chat-bubbles">

                                        <div class="chat-item" v-for="message in messages" :key="message.id" >
                                            <div class="row align-items-end" :class="{'justify-content-end': message.direction}">
                                                <div class="col col-lg-6"  :class="{'order-1': !message.direction}">
                                                    <div class="chat-bubble" :class="{'chat-bubble-me': message.direction}">
                                                        <div class="chat-bubble-title">
                                                            <div class="row">
                                                                <!--div class="col chat-bubble-author">{{ message.id }}</div-->
                                                                <div class="col-auto chat-bubble-date">{{ formatCreated(message.created) }}</div>
                                                            </div>
                                                        </div>
                                                        <div class="chat-bubble-body">
                                                            {{ message.text }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-auto">
                                                    <span class="avatar avatar-1" v-if="message.direction && selectedItem">
                                                        {{ convertEmoji(selectedItem.country_code) }}
                                                    </span>
                                                    <span class="avatar avatar-1" v-else-if="selectedItem">
                                                        <span v-html="require('@/assets/img/logo.svg').default" class="chat-logo" />
                                                    </span>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import api from "@/common/api";

export default {
    components: {},
    data() {
        return {
            loading: false,
            loadingDetail: false,
            items: [],
            selectedItem: null,
            messages: []
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        downloadCsv(csvString, fileName) {
            // Create a Blob from the CSV string with the proper MIME type
            const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
            // For IE 10+ compatibility
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, fileName);
            } else {
                // Create a temporary link element
                const link = document.createElement("a");
                // Create a URL for the Blob and set it as the href attribute
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                // Set the download attribute with the desired file name
                link.setAttribute("download", fileName);
                // Append the link to the DOM (this step is necessary for Firefox)
                document.body.appendChild(link);
                // Simulate a click on the link to trigger the download
                link.click();
                // Clean up by removing the link and revoking the Blob URL
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        },
        makeExport() {
            if (this.loadingDetail) {
                return;
            }

            this.loadingDetail = true;
            api.historyExport().then(data => {
                this.downloadCsv(data.csv, "export.csv");
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loadingDetail = false;
            });
        },
        formatDuration (seconds) {
            if (seconds >= 60) {
                const minutes = Math.floor(seconds / 60);
                const remainingSeconds = seconds % 60;
                return `${minutes}m ${remainingSeconds}s`;
            }
            return `${seconds}s`;
        },
        formatCreated (timestamp) {
            const date = new Date(timestamp * 1000);
            const day = date.getDate();
            const month = date.getMonth() + 1; // Months are zero-based
            const year = date.getFullYear();
            const hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensures two digits

            return `${day}-${month}-${year} ${hours}:${minutes}`;
        },
        convertEmoji(code) {
            if (!code || code.length < 1) {
                return "";
            }
            return code
                .toUpperCase()
                .split("")
                .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0))) // 127397 is the offset for regional indicator symbols
                .join("");
        },
        load() {
            this.loading = true;
            api.history().then(data => {
                this.items = data.items;
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loading = false;
            });
        },
        loadDetail(item) {
            if (this.loadingDetail) {
                return;
            }
            this.selectedItem = item;
            this.messsages = [];
            this.loadingDetail = true;
            api.historyMessages(item.id).then(data => {
                this.messages = data.items;
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loadingDetail = false;
            });
        }
    }
};
</script>
<style type="text/sass">
.chat-logo {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 80%;
        height: 80%;
    }
}
</style>
